import React, { Children, Fragment } from 'react';

export class CancelModal extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Fragment>
        <div className="modal opacity fixed w-full h-full top-0 left-0 flex items-center justify-center z-10">
          <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-75" />
          <div className="modal-container bg-white w-11/12 md:w-9/12 lg:w-4/12 mx-auto rounded shadow-lg z-50 overflow-y-auto">
            {/* Add margin if you want to see some of the overlay behind the modal*/}
            <div className="modal-content p-6 text-left">
              {/*Title*/}
              <div className="flex justify-end pb-3">
                <div
                  className="modal-close cursor-pointer z-50"
                  onClick={this.props.cancelEvent}
                >
                  <svg
                    className="fill-current text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width={18}
                    height={18}
                    viewBox="0 0 18 18"
                  >
                    <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                  </svg>
                </div>
              </div>
              {/*Body*/}
              <div className="modal__body text-center">
                <div className="site__logo w-24 m-auto">
                  <a href="index.html">
                    <img
                      className="w-full"
                      src="images/new-web-logo.png"
                      alt="Site Logo"
                    />
                    <span>Coacherly</span>
                  </a>
                </div>
                {/* -------- */}
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 mt-5">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <div className="mt-2">
                        <p className="text-sm leading-5 text-center">
                          {this.props.warningText}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:px-6 flex flex-row-reverse justify-center">
                  <span className="flex rounded-md shadow-sm sm:ml-3 w-auto">
                    <button
                      onClick={this.props.actionEvent}
                      type="button"
                      className="remove__button"
                    >
                      {this.props.actionText}
                    </button>
                  </span>
                  <span className="mr-2 flex rounded-md shadow-sm mt-0 w-auto">
                    <button
                      onClick={this.props.cancelEvent}
                      type="button"
                      className="discard__button"
                    >
                      {this.props.cancelText}
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default CancelModal;



// WEBPACK FOOTER //
// ./src/components/Modals/cancelModal.js